<template>
<div class="crawlseed" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
  <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
      <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
  </v-snackbar>
  <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
    <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
  </v-snackbar>
  <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
    <template >
      <v-toolbar flat>
          <v-toolbar-title style="margin-left: 20px;"><v-icon class="mx-2">mdi-earth</v-icon>List Crawl Seed </v-toolbar-title> 
          <v-spacer></v-spacer>
          <v-flex lg3>
            <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
          </v-flex>
        <!--v-dialog-->
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
                outlined
                v-show=insertact
                rounded 
                small
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                >
                Add New Crawl Seed
                <v-icon class="ml-2">mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
              <v-divider></v-divider>
              <v-card-text style="height: 400px;" class="overflow-card">
                <v-container> 
                  <h3 style="color: #0471A5;">Main Configuration</h3>
                  <v-row class="my-3">
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense v-model="inputItem.original_domain" :rules="original_domainrules" label="Domain" 
                      hint="Input Domain Name URL" persistent-hint>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea dense outlined rows="2" v-model="inputItem.landing_url" :rules="landing_urlrules" label="Landing URL"
                      hint="Input Landing URL to be crawled by system" persistent-hint></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea dense outlined rows="2" v-model="inputItem.index_pages" :rules="index_pagesrules" label="Index pages"
                      hint="Input Index Page url" persistent-hint></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense v-model="inputItem.schedule_minutes" :rules="schedule_minutesrules" label="Schedule every minutes" 
                      hint="Input Schedule Minutes" persistent-hint>
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <v-divider class="mb-4"></v-divider>
                  <h3 style="color: #0471A5;">Fetch Configuration</h3>
                  <v-row class="my-3">
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense v-model="inputItem.revisit_page_max_timestamp" :rules="revisit_page_max_timestamprules" label="Update Page Only After" 
                      hint="Input Update Page Only After" persistent-hint>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-checkbox dense label="Normalized URL"  v-model="inputItem.url_normalizer_enabled"  color="primary"></v-checkbox>


                      
                      <v-text-field outlined dense v-model="inputItem.max_depth_internal_links_depth" :rules="max_depth_internal_links_depthrules" label="Max Depth Internal Link" 
                      hint="Max Depth Internal Link" persistent-hint>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense v-model="inputItem.max_depth_external_links_depth" :rules="max_depth_external_links_depthrules" label="Max Depth External Link" 
                      hint="Max Depth External Link" persistent-hint>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea dense outlined rows="2" v-model="inputItem.url_regex_filter_regex_list" :rules="url_regex_filter_regex_listrules" label="URL Filter"
                      hint="URL Filter" persistent-hint></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea dense outlined rows="2" v-model="inputItem.subdomain_filter_regex_list" :rules="subdomain_filter_regex_listrules" label="Subdomain Filter"
                      hint="Subdomain Filter" persistent-hint></v-textarea>
                    </v-col>
                  </v-row>

                  <v-divider class="mb-4"></v-divider>
                  <h3 style="color: #0471A5;">Parse Configuration</h3>
                  <v-row class="my-3">
                    <v-col cols="12" sm="12" md="12">
                      <v-card-text class="ma-0 pa-0">CSS Selection Mode</v-card-text>
                      <v-select outlined dense :items="cssSelectionmode" item-text="name_parse" item-value="valueparse" v-model="css_selector_auto" value="Automatic"></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense v-model="inputItem.css_selector_el" :rules="css_selector_elrules" label="CSS Selector for parsing article" 
                      hint="CSS Selector for parsing article" persistent-hint>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-card-text class="ma-0 pa-0">CSS Selection Type</v-card-text>
                      <v-select outlined dense :items="cssSelectiontype" item-text="name_type" item-value="valuetype"  v-model="css_selector_type"  value="Paragraph Type"></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense v-model="inputItem.css_selector_date" :rules="css_selector_daterules" label="CSS Selector for parsing date" 
                      hint="CSS Selector for parsing date" persistent-hint>
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <v-divider class="mb-4"></v-divider>
                  <h3 style="color: #0471A5;">Analayzer</h3>
                  <v-row class="my-3">
                    <v-col cols="12" sm="12" md="12">
                      <v-checkbox dense label="NER and Statement " v-model="inputItem.ner_id_enabled" color="primary" ></v-checkbox>
                      <v-checkbox dense label="Sentiment Analysis" v-model="inputItem.sentiment_analysis_id_enabled" color="primary"></v-checkbox>
                      <v-checkbox dense label="Phrase" v-model="inputItem.phrase_id_enabled" color="primary"></v-checkbox>
                    </v-col> 
                  </v-row>

                  <v-divider class="mb-4"></v-divider>
                  <h3 style="color: #0471A5;">Upload Media Logo</h3>
                  <v-row class="my-3">
                    <v-col>
                      <v-file-input dense outlined accept="image/*" label="Include some file"
                      hint="Upload photo" persistent-hint></v-file-input>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense :loading="btnload" @click="save">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog> 

          <v-dialog v-model="dialogDelete" width="330px">
            <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
              <v-avatar class="color-avatar3 my-4" size="62">
                <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
              </v-avatar>
              <div class="text-center text-h6 align-center justify-center font-weight-medium">
                Confirm Deletion 
              </div>
              <v-card-text class="align-center justify-center mt-2">
                Are you sure you want to permanently delete this item?
              </v-card-text>

              <v-divider class="mt-4" style=""></v-divider>

              <v-card-actions class="align-center justify-center">
                <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                  OK
                </v-btn>
                <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-toolbar>
    </template>
    <v-data-table
      :headers="headers"
      :items="table"
      :search="search"
      item-key="id"
      class="table-user ml-6 mr-6 mt-4 rounded-lg"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon class="mr-2" small v-show=updateact  @click="editItem(item.media_online_scheduler_id)">
            mdi-pencil
          </v-icon>
          <v-icon small v-show=deleteact @click="deleteItem(item.media_online_scheduler_id)">
            mdi-delete
          </v-icon>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <!-- <template v-slot:expanded-item="{ headers, item }" >
          <td :colspan="headers.length" elevation="0" class="pa-3 elevation-0">
              <p> Auth token: {{ item.baseurl }}  </p>
              <p> Method : GET </p>
              <p> Endpoint : /youtube/v3/commentThreads?part=snippet%2Creplies&maxResults=100&videoId={VIDEO_ID}&key={YOUR_API_KEY} </p>
          </td>
        </template> -->
    </v-data-table>
  <Notification  ref="alert"></Notification>
</div>
</template>


<script>
import axios from "axios";
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
        btnload:false,
        alertSuccess:'',
        alertFailed:'',
        alert_err_attention: "",
      
        deleteact: false,
        insertact: false,
        updateact: false,
        viewact: false,
        dialog: false,
        dialogDelete: false,
        method: ['POST', 'GET', 'PUT', 'DELETE'],
        css_selector_auto: 'auto',
        cssSelectionmode: [//choice select
          {valueparse: 'auto', name_parse: "Automatic" },
          {valueparse: 'manual', name_parse: "Manual" }
        ],
        css_selector_type:'p',
        cssSelectiontype: [//choice select
          {valuetype: 'p', name_type: "Paragraph Type" },
          {valuetype: 'br', name_type: "Line Break Type" }
        ],
        expanded: [],
        singleExpand: false,
        page: [
        {
          text: 'Home',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Crawling Engine',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Media Online',
          disabled: false,
          href: 'breadcrumbs_link_2',
        },
        {
          text: 'Crawl Seed',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      search:'',
      headers: [
        // {
        //     text: 'ID',
        //     align: 'start',
        //     sortable: false,
        //     value: 'media_online_scheduler_id',
        //   },
          { text: 'Original Domain', value: 'original_domain' },
          { text: 'Landing URL', value: 'landing_url' },
          { text: 'Index Pages', value: 'index_pages' },
          { text: 'Schedule Minutes', value: 'schedule_minutes' },

          { text: 'Created Date', value: 'last_scheduled' },
          { text: 'Created By', value: 'add_by' },
          { text: 'Update Date', value: 'last_update' },
          { text: 'Actions', value: 'actions' },
      ],
      table:[],
      media_online_scheduler_id:'',
      original_domain_before:'',
      inputItem: {
      },
      defaultItem: {},
    }),
    computed: {
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Add Seed URL' : 'Update Seed URL'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      initialize () {

        axios.get("crawl-seed",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }
            // console.log(response.data);
            this.table = response.data;
            console.log()
            // end loading 
            setTimeout(() =>{
              this.loading = false
            },1000)
            
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });

      },
      deleteItem (item) {
        this.media_online_scheduler_id = item
        this.editedIndex = this.table.indexOf(item)
        this.inputItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.table.splice(this.editedIndex, 1)
         
        axios({
          method: "delete",
          url: "/crawl-seed/delete",
          data: {
            id: this.media_online_scheduler_id
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.initialize ();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.closeDelete()
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
          } 
        })
        .catch(function (error) {
          // handle error
          this.alertFailed = true;
          this.alert_err_attention =  'Delete Failed '+error;
        })
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.inputItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      editItem (item) {
        
        this.editedIndex = 1
        // this.editedIndex = this.table.indexOf(item)
        this.inputItem = Object.assign({}, item)
        this.dialog = true    
        axios({
          method: "put",
          url: "/crawl-seed-id",
          data: {
            id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            const dat = response.data;
            this.media_online_scheduler_id = dat.media_online_scheduler_id;
            this.original_domain_before =dat.original_domain;
            this.css_selector_type=dat.css_selector_type;
            this.css_selector_auto=dat.css_selector_auto;
            this.inputItem = {
              original_domain:dat.original_domain,
              landing_url:dat.landing_url,
              index_pages:dat.index_pages,
              schedule_minutes:dat.schedule_minutes,
              revisit_page_max_timestamp:dat.revisit_page_max_timestamp,
              max_depth_internal_links_depth:dat.max_depth_internal_links_depth,
              max_depth_external_links_depth:dat.max_depth_external_links_depth,
              url_regex_filter_regex_list:dat.url_regex_filter_regex_list,
              subdomain_filter_regex_list:dat.subdomain_filter_regex_list,
              css_selector_date:dat.css_selector_date,
              ner_id_enabled:dat.NER_id_enabled,
              css_selector_el:dat.css_selector_el,
              sentiment_analysis_id_enabled:dat.sentiment_analysis_id_enabled,
              phrase_id_enabled:dat.phrase_id_enabled,
              url_normalizer_enabled:dat.url_normalizer_enabled
            }
            setTimeout(() =>{
              this.loading = false
            },1000)
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      save () {
        this.btnload = true
        if (this.editedIndex > -1) {
          // alert(this.inputItem.url_normalizer_enabled);
          Object.assign(this.table[this.editedIndex], this.inputItem)
          axios.put("/crawl-seed/update", 
            {
              media_online_scheduler_id:this.media_online_scheduler_id,
              original_domain_before:this.original_domain_before,
              original_domain:this.inputItem.original_domain,
              landing_url:this.inputItem.landing_url,
              index_pages:this.inputItem.index_pages,
              schedule_minutes:this.inputItem.schedule_minutes,
              revisit_page_max_timestamp:this.inputItem.revisit_page_max_timestamp,
              max_depth_internal_links_depth:this.inputItem.max_depth_internal_links_depth,
              max_depth_external_links_depth:this.inputItem.max_depth_external_links_depth,
              url_regex_filter_regex_list:this.inputItem.url_regex_filter_regex_list,
              subdomain_filter_regex_list:this.inputItem.subdomain_filter_regex_list,
              css_selector_date:this.inputItem.css_selector_date,
              ner_id_enabled:this.inputItem.ner_id_enabled,
              sentiment_analysis_id_enabled:this.inputItem.sentiment_analysis_id_enabled,
              phrase_id_enabled:this.inputItem.phrase_id_enabled,
              url_normalizer_enabled:this.inputItem.url_normalizer_enabled,
              css_selector_type:this.css_selector_type,
              css_selector_auto:this.css_selector_auto
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
                var status = response.data.status
                var messages = response.data.msg
                if(status == 200){
                  this.initialize();
                  this.$router.push('/crawlseed');
                  this.alertSuccess = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.close()
                }else{
                    this.alertFailed = true;
                    this.alert_err_attention =  messages;
                    this.btnload = false
                    this.close()
                } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
        } 
        else {
          this.table.push(this.inputItem)
        } this.close()
        this.editedIndex = -1;
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.inputItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
    },
  }
</script>

<style scoped>
.v-file-input {
  flex-direction: row-reverse;
}
</style>

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>